import React from 'react'
import PlateType from './PlateType'
import { configContext } from '../DnaPlates'

const PackingAndShipping = (props) => {
  const { specificationsData, productDetails } = props
  const { dispatch } = React.useContext(configContext)
  React.useEffect(() => {
    window.scrollTo(0, 0)
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
  }, [])
  return (
    <div>
      <PlateType
        specificationsData={specificationsData}
        productDetails={productDetails}
      />
    </div>
  )
}

export default PackingAndShipping
